module.exports = __webpack_public_path__ + "3544f92da65cc31e0cab6f8a24fe1d48.png";